import $ from 'jquery';

export default function () {

    $('.js-hamburger').click(function hamburgerClick() {

        $('.js-hamburger').toggleClass('is-active');

        $('.js-main-menu').toggleClass('is-active');

    });

}
